import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { VictoryChart, VictoryLine, VictoryAxis, VictoryTooltip, VictoryVoronoiContainer } from 'victory';
import '../styles/patient-dashboard.css';
import Api from '../Api/Api.json';

const PatientDashboard = () => {
  // Function to fetch data using a POST request
  const fetchData = async () => {
    const response = await fetch(Api.PREGNANCY_DATA_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        // Add any required request body here
        task: 'getPatientDashboardData',
        patient_id: 130,
      }),
    });
    console.log(response);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  };

  // Use React Query to fetch and cache data
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['dashboardData'], // Unique key for this query
    queryFn: fetchData, // Function to fetch data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });

  // Format date to display only the date part (e.g., "2024-11-05")
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(); // Format based on the user's locale
  };

  // Prepare data for the chart
  const chartData = data
    ? data[1].map((item) => ({
        x: formatDate(item.date), // X-axis labels (dates)
        y: item.hrv, // Y-axis data (HRV values)
      }))
    : [];

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {error.message}</div>;

  return (
    <div className="dashboard">
      {/* Row 1 */}
      <div className="card">
        <h3>ANC List</h3>
        <ul>

        </ul>
      </div>
      <div className="card">
        <h3>Risk Factor List</h3>
        <ul>

        </ul>
      </div>

      {/* Row 2 */}
      <div className="card">
        <h3>HRV Graph</h3>
        <div style={{ width: '100%', height: '300px' }}>
          <VictoryChart
            containerComponent={
              <VictoryVoronoiContainer
                labels={({ datum }) => `Date: ${datum.x}, HRV: ${datum.y}`} // Tooltip content
              />
            }
          >
            <VictoryAxis
              label="Date" // X-axis label
              style={{
                tickLabels: { fontSize: 10, angle: -45, textAnchor: 'end' }, // Rotate X-axis labels for readability
              }}
            />
            <VictoryAxis
              dependentAxis // Y-axis
              label="HRV" // Y-axis label
              style={{
                tickLabels: { fontSize: 10 }, // Y-axis label styling
              }}
            />
            <VictoryLine
              data={chartData} // Data for the line
              style={{
                data: { stroke: '#8884d8', strokeWidth: 2 }, // Line styling
              }}
            />
          </VictoryChart>
        </div>
      </div>
      <div className="card">
        <h3>Sleep Graph</h3>
        <ul>

        </ul>
      </div>

      {/* Row 3 */}
      <div className="card">
        <h3>BP Graph</h3>
        <p>Content for BP Graph</p>
      </div>
      <div className="card">
        <h3>Walk Graph</h3>
        <p>Content for Walk Graph</p>
      </div>

      {/* Full Row */}
      <div className="card full-row">
        <h3>Summary</h3>
        <p>Content for Summary</p>
      </div>
    </div>
  );
};

export default PatientDashboard;